import * as React from 'react'
import styled from 'styled-components'

const fourOhOneImage =
  'https://res.cloudinary.com/ninety-seconds/image/upload/w_2048,h_1024,c_fill,f_auto,g_auto,e_brightness:-10/resources/shoot/background'
const fourOhFourImage =
  'https://res.cloudinary.com/ninety-seconds/image/upload/w_2048,h_1024,c_fill,f_auto,g_auto,e_brightness:-10/resources/edit/background'

interface Props {
  status?: number
}

const Container = styled.div`
  display: flex;
  background-size: cover;
  background-position: center center;
  background-color: black;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  line-height: 1;
  height: 100vh;
  background-image: url(${(props: Props) =>
    props.status === 401 ? fourOhOneImage : fourOhFourImage});
`

export const H1 = styled.h1`
  margin: 0 0 1rem;
  font-size: 5rem;
`
const H2 = styled.h2`
  margin: 0;
  font-size: 3rem;
`

const FourHundred: React.SFC<Props> = ({ status }) => (
  <Container status={status}>
    <H1>{status}</H1>
    <H2>{status === 401 ? 'Unauthorised' : 'Page not found'}</H2>
  </Container>
)

FourHundred.defaultProps = {
  status: 404,
}

export default FourHundred



// WEBPACK FOOTER //
// ./src/components/4xx/4xx.tsx